export interface FormResult {
  ok: boolean;
  message: string;
}

export async function submitForm(
  form: HTMLFormElement,
  endpoint: string,
): Promise<FormResult> {
  const formData = new FormData(form);
  const honeypot = ((formData.get('website_alt') as string | null) ?? '').trim();
  formData.delete('website_alt');

  if (honeypot) {
    return { ok: true, message: '' };
  }

  const body = new URLSearchParams();
  formData.forEach((value, key) => {
    if (typeof value === 'string' && value.trim() !== '') {
      body.append(key, value);
    }
  });

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    });
    const responseText = await response.text();
    let parsed: {
      code?: string;
      message?: string;
      meta?: { message?: string; detail?: string };
    } | null = null;
    try {
      parsed = JSON.parse(responseText);
    } catch {
      parsed = null;
    }
    const serverMsg =
      parsed?.meta?.message ||
      parsed?.message ||
      parsed?.meta?.detail ||
      responseText ||
      '';
    const isSpam = String(serverMsg).toLowerCase().includes('spam');
    if (!response.ok || parsed?.code !== 'OK' || isSpam) {
      return { ok: false, message: serverMsg || '提交失败，请稍后再试' };
    }
    return { ok: true, message: '' };
  } catch {
    return { ok: false, message: '网络开小差了，请稍后再试' };
  }
}